<template>
    <v-row class="new_context">
        <v-col>
            <v-form lazy-validation
                    ref="main_form"
                    v-model="is_valid"
                    :disabled="locked">
                <!-- User -->
                <v-row v-if="is_admin">
                    <v-col cols="12" class="title">
                        <h2>Usuário alternativo</h2>
                    </v-col>
                </v-row>
                <v-row v-if="is_admin">
                    <v-col cols="6">
                        <label for="gp_user">Usuário</label>
                    </v-col>
                    <v-col cols="6">
                        <v-autocomplete color="secondary"
                                        v-model="request.userId"
                                        :items="users"
                                        item-text="fullname"
                                        item-value="userId"
                                        placeholder="Selecione o usuário..."></v-autocomplete>
                    </v-col>
                </v-row>
                <!-- Pagar Me -->
                <v-row>
                    <v-col cols="12" class="title">
                        <h2>Pagar.me</h2>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <label for="pm_key">Key</label>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field color="secondary"
                                      v-model="request.pagarMe.key"
                                      id="pm_key"
                                      placeholder="Chave Pagar me"></v-text-field>
                    </v-col>
                </v-row>
                <!-- Pluggy -->
                <v-row>
                    <v-col cols="12" class="title">
                        <h2>Pluggy</h2>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <label for="pg_svc">Url do serviço</label>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field color="secondary"
                                      v-model="request.pluggy.serviceUrl"
                                      id="pg_svc"
                                      placeholder="Url serviço Pluggy"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <label for="pg_id">Identificador da conta (<span>*</span>)</label>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field color="secondary"
                                      v-model="request.pluggy.clientId"
                                      id="pg_id"
                                      required
                                      :rules="[(v) => !!v || 'Id de conta pluggy requerido!']"
                                      placeholder="Id da conta Pluggy"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <label for="pg_key">Chave da conta (<span>*</span>)</label>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field color="secondary"
                                      v-model="request.pluggy.clientKey"
                                      id="pg_key"
                                      required
                                      :rules="[(v) => !!v || 'Chave de conta Pluggy requerida!']"
                                      placeholder="Chave da conta Pluggy"></v-text-field>
                    </v-col>
                </v-row>
                <!-- Email -->
                <v-row>
                    <v-col cols="12" class="title">
                        <h2>E-mail</h2>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <label for="em_smtp">Servidor SMTP</label>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field color="secondary"
                                      v-model="request.email.smtp"
                                      id="em_smtp"
                                      placeholder="Servidor SMTP"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <label for="em_mail">Endereço do remetente</label>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field color="secondary"
                                      v-model="request.email.email"
                                      id="em_mail"
                                      placeholder="Endereço para mensagens enviadas"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <label for="em_user">Usuário (autenticação)</label>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field color="secondary"
                                      v-model="request.email.user"
                                      id="em_user"
                                      placeholder="Usuário para autenticação"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <label for="em_pwd">Senha (autenticação)</label>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field color="secondary"
                                      v-model="request.email.password"
                                      id="em_pwd"
                                      type="password"
                                      placeholder="Senha para autenticação"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <label for="em_port">Porta</label>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field color="secondary"
                                      v-model="request.email.port"
                                      id="em_smtp"
                                      type="number"
                                      hide-spin-buttons
                                      placeholder="Porta"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <label for="em_opts">Opções de conexão</label>
                    </v-col>
                    <v-col cols="6">
                        <v-select color="secondary"
                                  :items="mailOptions"
                                  item-text="title"
                                  item-value="value"
                                  placeholder="Opções de segurança"></v-select>
                    </v-col>
                </v-row>
                <!-- Cmd row -->
                <v-row>
                    <v-col cols="12">
                        <v-row class="justify-center">
                            <v-btn color="primary"
                                   @click="createContext($event)"
                                   :disabled="!is_valid || locked">
                                Criar grupo
                            </v-btn>
                        </v-row>
                    </v-col>
                </v-row>
            </v-form>
        </v-col>
    </v-row>
</template>

<style lang="css" scoped>
.new_context h2 {
    font-size: 1rem;
}
.new_context h3 {
    font-size: 1rem;
}
.new_context {
    height: fit-content;
}
.new_context button {
    width: 33.333%;
    border-radius: 10px;
    font-weight: bold;
}
.new_context button:disabled {
    background-color: #CCCCCC;
}
</style>

<style lang="css">
.v-input {
    margin: 0;
    padding: 0;
}
.v-input .v-icon {
    cursor: default;
}
.v-input__control .v-input__slot {
    margin-bottom: 0;
}
.v-input input {
    font-size: 1rem;
    height: 1.25rem;
    padding-left: 0.5rem;
}
.row > .col {
    padding: 8px;
    vertical-align: top;
    align-content: top;
}
.col.title {
    background-color: #CCCCCC;
    color: white;
    padding: 0px 0px 0px 8px;
    margin: 0;
}
label span {
    color: red;
    font-weight: bold;
}
</style>

<script lang="js">
import client from '../../../../services/AdminService';

export default                {
    props                     : {
        locked                : { type: Boolean }
    },
    data                      () {
        return                {
            client,
            is_valid          : false,
            is_admin          : false,
            users             : [],
            mailOptions       : [
                {
                    title     : 'Determinar automticamente',
                    value     : 'auto'
                },
                {
                    title     : 'Usar conexão criptografada (necessita suporte)',
                    value     : 'sslOnConnect'
                },
                {
                    title     : 'Usar envio criptografado (necessita suporte)',
                    value     : 'startTls'
                },
                {
                    title     : 'Usar envio criptografado (se disponível)',
                    value     : 'startTlsWhenAvailable'
                }
            ],
            request           : {
                userId        : '',
                pagarMe       : {
                    key       : ''
                },
                pluggy        : {
                    serviceUrl: 'https://api.pluggy.ai/',
                    clientId  : '',
                    clientKey : ''
                },
                email         : {
                    smtp      : '',
                    email     : '',
                    user      : '',
                    password  : '',
                    options   : 'auto',
                    port      : 587,
                }
            }
        }
    },
    methods                   : {
        fullStateCheck        () {
            this.is_valid     = this.$refs.main_form.validate();
        },
        async createContext   (ev) {
            ev && ev.preventDefault();
            this.fullStateCheck();
            if (this.locked) { return; }
            try {
                this.$emit('loading', true);
                const resp = await this.client.createUserContext(this.request);
                if (!resp.success) {
                    this.$toast.error(resp.message || 'Falha não identificada');
                    return;
                }
                const data = resp.content;
                this.$toast.info(data || 'Grupo criado!');
                setTimeout(() => {
                    this.client.doLogout(this.$router);
                }, 2000);
            } catch (e) {
                this.$toast.error(e.message || 'Erro não identificado');
            } finally {
                this.$emit('loading', false);
            }
        },
        async getUsers        () {
            if (this.locked) { return; }
            try {
                this.$emit('loading', true);
                const resp = await this.client.getNoContextUsers();
                if (!resp.success) {
                    this.$toast.error(resp.message || 'Falha não identificada');
                    return;
                }
                const data = resp.content;
                this.users.length = 0;
                this.users.push(...data);
            } catch (e) {
                this.$toast.error(e.message || 'Erro não identificado');
            } finally {
                this.$emit('loading', false);
            }
        }
    },
    computed                  : {
        emailPort             () {
            return this.request.email.port;
        }
    },
    watch                     : {
        emailPort             (value) {
            if (typeof value === 'string') {
                this.request.email.port = value && (+value) || 0;
            }
        }
    },
    mounted                   () {
        this.is_admin         = this.$store &&
                                this.$store.getters &&
                                this.$store.getters.$user &&
                                this.$store.getters.$user.systemRoleId &&
                                this.$store.getters.$user.systemRoleId === 1 ||
                                false;
        if (this.is_admin) {
            return this.getUsers();
        }
        return Promise.resolve();
    }
}
</script>